"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LHYPE_ATOMIC_QUEUE_ADDRESS = exports.LHYPE_DEPOSITOR_ADDRESS = exports.LHYPE_ACCOUNTANT_ADDRESS = exports.LHYPE_ADDRESS = exports.STHYPE_OVERSEER_ADDRESS = exports.STHYPE_ADDRESS = exports.HSPX_ADDRESS = exports.XHSPX_ADDRESS = exports.MASTERCHIEF_ADDRESS = exports.LAUNCHER_ADDRESS = exports.MULTICALL2_ADDRESS = exports.V3_MIGRATOR_ADDRESS = exports.SWAP_ROUTER_ADDRESS = exports.NONFUNGIBLE_POSITION_MANAGER_ADDRESS = exports.TICK_LENS_ADDRESS = exports.QUOTERV2_ADDRESS = exports.V3_SINGLE_SIDE_ADDRESS = exports.V3_INIT_CODE_HASH = exports.V3_FACTORY_ADDRESS = exports.V2_ROUTER_FOR_CAMPAIGN = exports.V2_ROUTER_ADDRESS = exports.V2_INIT_CODE_HASH = exports.V2_FACTORY_ADDRESS = exports.V3_ADDRESSES = exports.V2_ADDRESSES = exports.OTHER_ADDRESSES = exports.WETH9_ADDRESSES = exports.CHAINS = exports.ETHERSCAN_BASE_URL = exports.CURRENT_CHAIN = exports.ChainId = void 0;
var ChainId;
(function (ChainId) {
    ChainId[ChainId["MAINNET"] = 1] = "MAINNET";
    ChainId[ChainId["HYPEREVM_TESTNET"] = 998] = "HYPEREVM_TESTNET";
    ChainId[ChainId["HYPEREVM"] = 999] = "HYPEREVM";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
exports.CURRENT_CHAIN = ChainId.HYPEREVM;
exports.ETHERSCAN_BASE_URL = {
    1: 'etherscan.io',
    998: 'testnet.purrsec.com',
    999: 'purrsec.com',
};
exports.CHAINS = {
    [ChainId.MAINNET]: {
        chainId: `0x1`,
        chainName: 'Ethereum Mainnet',
        nativeCurrency: {
            name: 'Ether',
            symbol: 'ETH',
            decimals: 18,
        },
        rpcUrls: ['https://eth.llamarpc.com'],
        blockExplorerUrls: ['https://etherscan.io'],
    },
    [ChainId.HYPEREVM_TESTNET]: {
        chainId: `0x3E6`,
        chainName: 'HyperEVM Testnet',
        nativeCurrency: {
            name: 'HYPE',
            symbol: 'HYPE',
            decimals: 18,
        },
        rpcUrls: ['https://rpc.hyperliquid-testnet.xyz/evm'],
        blockExplorerUrls: ['https://testnet.purrsec.com'],
    },
    [ChainId.HYPEREVM]: {
        chainId: `0x3E7`,
        chainName: 'HyperEVM',
        nativeCurrency: {
            name: 'HYPE',
            symbol: 'HYPE',
            decimals: 18,
        },
        rpcUrls: ['https://rpc.hyperliquid.xyz/evm'],
        blockExplorerUrls: ['https://purrsec.com'],
    },
};
exports.WETH9_ADDRESSES = {
    [ChainId.MAINNET]: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    [ChainId.HYPEREVM_TESTNET]: '0xADcb2f358Eae6492F61A5F87eb8893d09391d160',
    [ChainId.HYPEREVM]: '0x5555555555555555555555555555555555555555',
};
exports.OTHER_ADDRESSES = {
    [ChainId.MAINNET]: {
        LAUNCHER_ADDRESS: '0x67eD55aaAAe4d6a727d4B16C4E9253572A3E8927',
        MASTERCHIEF_ADDRESS: '0x77E86cE7A0E6FEb5f082335b0c9F00D80Ba7730F',
        XHSPX_ADDRESS: '0x7166874527c618A920d64A95Df48A0A50bA94a5E',
        HSPX_ADDRESS: '0x9ac3889B2259b42D4DEE9416090181BA9D1e0D66',
        STHYPE_ADDRESS: '0xe2FbC9cB335A65201FcDE55323aE0F4E8A96A616',
        STHYPE_OVERSEER_ADDRESS: '0x371de8EBDA2ebB627a4f6d92bD6d01eC385A309b',
        LHYPE_ADDRESS: '',
        LHYPE_ACCOUNTANT: '',
        LHYPE_DEPOSITOR: '',
        LHYPE_ATOMIC_QUEUE: '',
    },
    [ChainId.HYPEREVM_TESTNET]: {
        LAUNCHER_ADDRESS: '0x65D574ab94579B8FC8DCCb63Ea1A01227C68304F',
        MASTERCHIEF_ADDRESS: '0x33861eafb115f32555855f34DB97B9f500CDB0c1',
        XHSPX_ADDRESS: '0x91483330b5953895757b65683d1272d86d6430B3',
        HSPX_ADDRESS: '0xD8c23394e2d55AA6dB9E5bb1305df54A1F83D122',
        STHYPE_ADDRESS: '',
        STHYPE_OVERSEER_ADDRESS: '',
        LHYPE_ADDRESS: '',
        LHYPE_ACCOUNTANT: '',
        LHYPE_DEPOSITOR: '',
        LHYPE_ATOMIC_QUEUE: '',
    },
    [ChainId.HYPEREVM]: {
        LAUNCHER_ADDRESS: '0xb583880c52Aca242D04e7c626385D21c07DcAD46',
        MASTERCHIEF_ADDRESS: '',
        XHSPX_ADDRESS: '',
        HSPX_ADDRESS: '',
        STHYPE_ADDRESS: '0xfFaa4a3D97fE9107Cef8a3F48c069F577Ff76cC1',
        STHYPE_OVERSEER_ADDRESS: '0xB96f07367e69e86d6e9C3F29215885104813eeAE',
        LHYPE_ADDRESS: '0x5748ae796AE46A4F1348a1693de4b50560485562',
        LHYPE_ACCOUNTANT: '0xcE621a3CA6F72706678cFF0572ae8d15e5F001c3',
        LHYPE_DEPOSITOR: '0x6e358dd1204c3fb1D24e569DF0899f48faBE5337',
        LHYPE_ATOMIC_QUEUE: '0x228C44Bb4885C6633F4b6C83f14622f37D5112E5',
    },
};
exports.V2_ADDRESSES = {
    [ChainId.MAINNET]: {
        FACTORY_ADDRESS: '0x3762bb66Ac2618c00380bcC2F7d5974298272d1b',
        INIT_CODE_HASH: '0x4e3dd9233019c8b078fd38e85c7da5c7a68e375de3ff1efead1192b7a48c9424',
        V2_ROUTER_ADDRESS: '0x1fB030BB294fEeA447C565e2CCbc592EC5636693',
        ROUTER_FOR_CAMPAIGNS: '0x4505ab7D68aEcB72d453b513d639D13FE3ADa2CB',
    },
    [ChainId.HYPEREVM_TESTNET]: {
        FACTORY_ADDRESS: '0x67Fa1223bAd44F1a2eD15b6cE5E5BB962bdc9476',
        INIT_CODE_HASH: '0x2f41747f55ff5af6eea20e25863becb514cab0806fae4464976c35568575693a',
        V2_ROUTER_ADDRESS: '0xD19222370B1944a5392f98028C3E70AFD3a673dF',
        ROUTER_FOR_CAMPAIGNS: '0x562D7424c2D2a4af631fD02BA4567B4306c4A58F',
    },
    [ChainId.HYPEREVM]: {
        FACTORY_ADDRESS: '0x724412C00059bf7d6ee7d4a1d0D5cd4de3ea1C48',
        INIT_CODE_HASH: '0xc83d9df19c8c8a0a1229bd3122cbb86fd8ff56f79cc6781c15999d39425466e9',
        V2_ROUTER_ADDRESS: '0xb4a9C4e6Ea8E2191d2FA5B380452a634Fb21240A',
        ROUTER_FOR_CAMPAIGNS: '', //MISSING
    },
};
exports.V3_ADDRESSES = {
    [ChainId.MAINNET]: {
        FACTORY_ADDRESS: '0x22B0768972bB7f1F5ea7a8740BB8f94b32483826',
        INIT_CODE_HASH: '0xe3572921be1688dba92df30c6781b8770499ff274d20ae9b325f4242634774fb',
        TICK_LENS_ADDRESS: '0x665d14daA7De0538AdC170aF94D2CD86f9b60d76',
        NONFUNGIBLE_POSITION_MANAGER_ADDRESS: '0x09Aca834543b5790DB7a52803d5F9d48c5b87e80',
        V3_MIGRATOR_ADDRESS: '0xE23a8F1e6b74DF0f2b841b4d37F8e57D4e26ccD8',
        QUOTERV2_ADDRESS: '0x7FEd8993828A61A5985F384Cee8bDD42177Aa263',
        SWAP_ROUTER_ADDRESS: '0xD81F56576B1FF2f3Ef18e9Cc71Adaa42516fD990',
        MULTICALL2_ADDRESS: '0xDB2b93F421C5D1b3Dc5763B841652aA68Fa9A373',
        SINGLE_SIDE_ADDRESS: '0x093dE46C90bEA4A730b1914748cC43d909b53661',
    },
    [ChainId.HYPEREVM_TESTNET]: {
        FACTORY_ADDRESS: '0x22B0768972bB7f1F5ea7a8740BB8f94b32483826',
        INIT_CODE_HASH: '0xe3572921be1688dba92df30c6781b8770499ff274d20ae9b325f4242634774fb',
        TICK_LENS_ADDRESS: '0x665d14daA7De0538AdC170aF94D2CD86f9b60d76',
        NONFUNGIBLE_POSITION_MANAGER_ADDRESS: '0x09Aca834543b5790DB7a52803d5F9d48c5b87e80',
        V3_MIGRATOR_ADDRESS: '0xE23a8F1e6b74DF0f2b841b4d37F8e57D4e26ccD8',
        QUOTERV2_ADDRESS: '0x7FEd8993828A61A5985F384Cee8bDD42177Aa263',
        SWAP_ROUTER_ADDRESS: '0xD81F56576B1FF2f3Ef18e9Cc71Adaa42516fD990',
        MULTICALL2_ADDRESS: '0xDB2b93F421C5D1b3Dc5763B841652aA68Fa9A373',
        SINGLE_SIDE_ADDRESS: '0x093dE46C90bEA4A730b1914748cC43d909b53661',
    },
    [ChainId.HYPEREVM]: {
        FACTORY_ADDRESS: '0xB1c0fa0B789320044A6F623cFe5eBda9562602E3',
        INIT_CODE_HASH: '0xe3572921be1688dba92df30c6781b8770499ff274d20ae9b325f4242634774fb',
        TICK_LENS_ADDRESS: '0x8F1eA97FfDfEDA3bE7EabfED95eF49f909b2975A',
        NONFUNGIBLE_POSITION_MANAGER_ADDRESS: '0x6eDA206207c09e5428F281761DdC0D300851fBC8',
        V3_MIGRATOR_ADDRESS: '0x820Ec81E0556f2f94f4725D358b399c11Cd78cf8',
        QUOTERV2_ADDRESS: '0x03A918028f22D9E1473B7959C927AD7425A45C7C',
        SWAP_ROUTER_ADDRESS: '0x4E2960a8cd19B467b82d26D83fAcb0fAE26b094D',
        MULTICALL2_ADDRESS: '0xD86d0F9419FfE3c81dAa7621ec1809127e7Da315',
        SINGLE_SIDE_ADDRESS: '0x093dE46C90bEA4A730b1914748cC43d909b53661',
    },
};
exports.V2_FACTORY_ADDRESS = exports.V2_ADDRESSES[exports.CURRENT_CHAIN].FACTORY_ADDRESS;
exports.V2_INIT_CODE_HASH = exports.V2_ADDRESSES[exports.CURRENT_CHAIN].INIT_CODE_HASH;
exports.V2_ROUTER_ADDRESS = exports.V2_ADDRESSES[exports.CURRENT_CHAIN].V2_ROUTER_ADDRESS;
exports.V2_ROUTER_FOR_CAMPAIGN = exports.V2_ADDRESSES[exports.CURRENT_CHAIN].ROUTER_FOR_CAMPAIGNS;
exports.V3_FACTORY_ADDRESS = exports.V3_ADDRESSES[exports.CURRENT_CHAIN].FACTORY_ADDRESS;
exports.V3_INIT_CODE_HASH = exports.V3_ADDRESSES[exports.CURRENT_CHAIN].INIT_CODE_HASH;
exports.V3_SINGLE_SIDE_ADDRESS = exports.V3_ADDRESSES[exports.CURRENT_CHAIN].SINGLE_SIDE_ADDRESS;
exports.QUOTERV2_ADDRESS = exports.V3_ADDRESSES[exports.CURRENT_CHAIN].QUOTERV2_ADDRESS;
exports.TICK_LENS_ADDRESS = exports.V3_ADDRESSES[exports.CURRENT_CHAIN].TICK_LENS_ADDRESS;
exports.NONFUNGIBLE_POSITION_MANAGER_ADDRESS = exports.V3_ADDRESSES[exports.CURRENT_CHAIN].NONFUNGIBLE_POSITION_MANAGER_ADDRESS;
exports.SWAP_ROUTER_ADDRESS = exports.V3_ADDRESSES[exports.CURRENT_CHAIN].SWAP_ROUTER_ADDRESS;
exports.V3_MIGRATOR_ADDRESS = exports.V3_ADDRESSES[exports.CURRENT_CHAIN].V3_MIGRATOR_ADDRESS;
exports.MULTICALL2_ADDRESS = exports.V3_ADDRESSES[exports.CURRENT_CHAIN].MULTICALL2_ADDRESS;
exports.LAUNCHER_ADDRESS = exports.OTHER_ADDRESSES[exports.CURRENT_CHAIN].LAUNCHER_ADDRESS;
exports.MASTERCHIEF_ADDRESS = exports.OTHER_ADDRESSES[exports.CURRENT_CHAIN].MASTERCHIEF_ADDRESS;
exports.XHSPX_ADDRESS = exports.OTHER_ADDRESSES[exports.CURRENT_CHAIN].XHSPX_ADDRESS;
exports.HSPX_ADDRESS = exports.OTHER_ADDRESSES[exports.CURRENT_CHAIN].HSPX_ADDRESS;
exports.STHYPE_ADDRESS = exports.OTHER_ADDRESSES[exports.CURRENT_CHAIN].STHYPE_ADDRESS;
exports.STHYPE_OVERSEER_ADDRESS = exports.OTHER_ADDRESSES[exports.CURRENT_CHAIN].STHYPE_OVERSEER_ADDRESS;
exports.LHYPE_ADDRESS = exports.OTHER_ADDRESSES[exports.CURRENT_CHAIN].LHYPE_ADDRESS;
exports.LHYPE_ACCOUNTANT_ADDRESS = exports.OTHER_ADDRESSES[exports.CURRENT_CHAIN].LHYPE_ACCOUNTANT;
exports.LHYPE_DEPOSITOR_ADDRESS = exports.OTHER_ADDRESSES[exports.CURRENT_CHAIN].LHYPE_DEPOSITOR;
exports.LHYPE_ATOMIC_QUEUE_ADDRESS = exports.OTHER_ADDRESSES[exports.CURRENT_CHAIN].LHYPE_ATOMIC_QUEUE;
